import CommissionType from 'src/features/finance/commissionStatement/constants/commissionType';
import ViewCommissionsPage from 'src/pages/ViewCommissionsPage/ViewCommissionsPage';

const ViewTerminalCommissionsPage = () => {
    return <ViewCommissionsPage commissionType={CommissionType.TERMINAL} />;
};
export default ViewTerminalCommissionsPage;
